export default __webpack_public_path__ + "static/media/loading.8de0efea.flr";